module.exports = __webpack_public_path__ + "media/images/flags/4x3/fji-7e4e2c498a78689aa6d9dc7f4ab417ad.svg";